<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <b-card header-tag="header" footer-tag="footer">
          <div slot="header">
            <strong>{{ status == 'RTO Dispatch' ? 'RTO Received in LPC' : status == 'RTO Received' ? 'Rintransit LMD TO LPC' : status }}</strong>
          </div>
          <div id="overlay" >
            <div class="loader"></div>
          </div>
          <b-row>
            <b-col md="12">
              <div class="tab-panel">
                <b-row class="mt-2">
                  <b-col md="12" class="my-1 text-right">
                    <b-button v-if="this.totalRows > 0" variant="primary" size="md" @click="downloadCSV">
                      Download
                    </b-button>
                  </b-col>
                  <b-col sm="12" class="text-right">
                    <p><b>Total Records: <span style="color:red;">{{ this.totalRows }}</span></b></p>
                  </b-col>
                </b-row>

                <b-table
                  show-empty
                  responsive
                  :items="items"
                  :fields="fields"
                  :current-page="currentPage"
                  :per-page="perPage"
                  :busy="isBusy"
                >
                  <div slot="table-busy" class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                  </div>

                  <template slot="shipmenttype" slot-scope="row">
                    <p v-if="status == 'RTO Dispatch' || status == 'RTO Received' || status == 'RTO Handover to WH'">{{row.item.shippingid.startsWith('R') ? 'RVP' : 'RTO'}}</p>
                  </template>
                </b-table>
              </div>
            </b-col>
          </b-row>
          <b-col md="12" class="my-1">
            <paginate
              :page-count="noofpages"
              :page-range="10"
              :margin-pages="2"
              :click-handler="clickCallback"
              :prev-text="'Prev'"
              :next-text="'Next'"
              :container-class="'pagination'"
              :page-class="'page-item'"
            ></paginate>
          </b-col>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import CONSTANTS from '@/utils/constants';
import Utils from '@/utils';
import auth from '@/utils/auth';

export default {
  data() {
    return {
      items: [],
      fields: [],
      isBusy: false,
      currentPage: 1,
      perPage: 15,
      totalRows: 0,
      sortBy: '',
      sortDesc: false,
      filter: null,
      status: null,
      vendor_id: null,
      shipment_type: null,
      bordered: true,
      outlined: true,
      hub_id: null,
      downloadLoading: false,
    };
  },
  computed: {
    sortOptions() {
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    },
    noofpages() {
      return Math.ceil(this.totalRows / this.perPage);
    }
  },
  created() {
    this.status = this.$route.params.status || null;
    this.vendor_id = this.$route.params.vendor_id || null;
    this.shipment_type = this.$route.params.shipmenttype || null;
    this.hub_id = this.$route.params.hub_id || null;
    if (this.status == 'Ready to Allocate the Rider' ||this.status == 'Rider Pickup Pending' || this.status == 'Rider Pickup Done' || this.status == 'Received in Hub' || this.status == 'Shipment Received' || this.status == 'HUB Inscan') {
      this.fields = [
        { key: "shippingid", label: "Shipping ID" },
        { key: "destination", label: "Destination HUB", class: "text-center" },
        { key: "shipmentstatus", label: "Shipment Status" },
        { key: "aging_in_days", label: "Ageing Day", class: "text-center"},
        { key: "consignmenttype", label: "Delivery Type", class: "text-center" },
        { key: "lastmodifieddate", label: "Last Modified Date" },
        { key: "clientedd", label: "EDD" },
        { key: "sourcename", label: "Source Name" }
      ];
    }
    else if(this.status == 'Shipment Created'){
      this.fields = [
        { key: "shippingid", label: "Shipping ID" },
        { key: "destination", label: "Destination HUB", class: "text-center" },
        { key: "shipmentstatus", label: "Shipment Status" },
        { key: "aging_in_days", label: "Shipment Created Ageing Day", class: "text-center"},
        { key: "consignmenttype", label: "Delivery Type", class: "text-center" },
        { key: "createddate", label: "Shipment Created Date" },
        { key: "clientedd", label: "EDD" },
        { key: "edd_remaining_days", label: "EDD Remaining Day", class: "text-center" },
        { key: "sourcename", label: "Source Name" }
      ];
    }else if(this.status == 'Pallet Created' || this.status == 'Pallet Closed' ){
      this.fields = [
        { key: "shippingid", label: "Shipping ID" },
        { key: "destination", label: "Destination HUB", class: "text-center" },
        { key: "shipmentstatus", label: "Shipment Status" },
        { key: "aging_in_days", label: "Pallet Scan Ageing Day", class: "text-center"},
        { key: "consignmenttype", label: "Delivery Type", class: "text-center" },
        { key: "lastmodifieddate", label: "Pallet Scan Date" },
        { key: "pallet_title", label: "Pallet Name" },
        { key: "sourcename", label: "Source Name" },
        { key: "lastmodifiedby", label: "Scanner User Name" }
      ];
    }else if(this.status == 'Dispatch from LPC' || this.status == 'Dispatch Pending'){
      this.fields = [
        { key: "shippingid", label: "Shipping ID" },
        { key: "destination", label: "Destination HUB", class: "text-center" },
        { key: "shipmentstatus", label: "Shipment Status" },
        { key: "aging_in_days", label: "Ageing Day", class: "text-center"},
        { key: "consignmenttype", label: "Delivery Type", class: "text-center" },
        { key: "lastmodifieddate", label: "Last Modified Date" },
        { key: "lastmodifiedby", label: "Last Modified By" },
        { key: "sourcename", label: "Source Name" },
        { key: "master_awb", label: "Master AWB" }
      ];
    }
    else if(this.status == 'RTO Dispatch' || this.status == 'RTO Received' || this.status == 'RTO Handover to WH'){
      this.fields = [
        { key: "shippingid", label: "Shipping ID" },
        { key: "shipmenttype", label: "Shipment Type", class: "text-center" },
        { key: "destination", label: "RTO Send From" },
        { key: "shipmentstatus", label: "Shipment Status" },
        { key: "aging_in_days", label: this.status == 'RTO Dispatch' ? "RInScan Ageing Day" : this.status == 'RTO Received' ? "RInTransit Ageing Day" : "Ageing Day" , class: "text-center" },
        { key: "lastmodifieddate", label: this.status == 'RTO Dispatch' ? "RInScan Date" : this.status == 'RTO Received' ? "RInTransit Date" : "Last Modified Date" },
        { key: "source_name", label: "Return Origin Source Name" },
      ];
    }
    else{
      this.fields = [
        { key: "shippingid", label: "Shipping ID" },
        { key: "destination", label: "Destination HUB", class: "text-center" },
        { key: "shipmentstatus", label: "Shipment Status" },
        { key: "aging_in_days", label: "Ageing Day", class: "text-center"},
        { key: "consignmenttype", label: "Delivery Type", class: "text-center" },
        { key: "lastmodifieddate", label: "Last Modified Date" },
        { key: "lastmodifiedby", label: "Last Modified By" },
        { key: "sourcename", label: "Source Name" },
        { key: "master_awb", label: "Master AWB" }
      ];
    }
    this.getShipmentReportListing();
  },
  methods: {
    getShipmentReportListing(page) {
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      this.isBusy = true;
      // document.getElementById('overlay').style.display = "block";
      
      const obj = {
        hub_id: this.status == 'Dispatch Pending' ? this.hub_id : userInfo.pickuplocationmasterid ? userInfo.pickuplocationmasterid : null,
        status: this.status,
        vendor_id: this.vendor_id,
        shipment_type: this.shipment_type,
        pageno: page ? page : 1, 
        limit: this.perPage
      };
      this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getShipmentReportListing_ksa`, obj)
        .then(result => {
          if (result.body.returnmsg === "Successful") {
            this.items = result.body.returnvalue;
            this.totalRows = result.body.returnvalue[0].totalcount;
            this.noofpages = Math.ceil(this.totalRows / this.perPage);
          } else {
            this.items = [];
            this.totalRows = 0;
            this.noofpages = 0;
          }
        })
        .catch(error => {
          console.error("Error fetching data:", error);
          this.items = [];
          this.totalRows = 0;
          this.noofpages = 0;
        })
        .finally(() => {
          this.isBusy = false;
          // document.getElementById('overlay').style.display = "none";
        });
    },
    clickCallback(pageNum) {
      this.getShipmentReportListing(pageNum);
    },
    downloadCSV() {
      document.getElementById("overlay").style.display = "block";
      const userdata = localStorage.getItem('userData');
      const userInfo = JSON.parse(userdata);

      let obj = {
        hub_id: this.status == 'Dispatch Pending' ? this.hub_id : userInfo.pickuplocationmasterid ? userInfo.pickuplocationmasterid : null,
        status: this.status,
        vendor_id: this.vendor_id,
        shipment_type: this.shipment_type,
        sysusermasterid:`${userInfo.sysusermasterid}`, 
      };

      this.$http
        .post(`${CONSTANTS.MISREPORT_API_URL}/dashboardshipmentlistcsv_ksa`, obj)
        .then(result => {
          document.getElementById("overlay").style.display = "none";
          if (result.body === "success") {
            this.$fire({
              text: "Please check your mail for download link",
              type: "success",
              timer: 30000
            });
          } else {
            this.$fire({
              text: "Cannot Download",
              type: "warning",
              timer: 30000
            });
          }
        })
        .catch(() => {
          document.getElementById("overlay").style.display = "none";
          this.$fire({
            text: "Download failed",
            type: "error",
            timer: 30000
          });
        });
    },
    toTitleCase(str) {
      return str.replace(/_|-/g, ' ')
                .split(' ')
                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                .join(' ');
    }
  }
};
</script>